<svg width="30" height="4" viewBox="0 0 30 4" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M2 2H28" stroke="url(#paint0_linear_5081_29600)" stroke-width="4" stroke-linecap="round" stroke-dasharray="0.1 8"/>
<defs>
<linearGradient id="paint0_linear_5081_29600" x1="2" y1="2.5" x2="28" y2="2.5" gradientUnits="userSpaceOnUse">
<stop stop-color="#9FA1A4"/>
<stop offset="1" stop-color="#3C3D3E"/>
</linearGradient>
</defs>
</svg>
